module.exports = __webpack_public_path__ + "static/media/balloon-1.bb74e165.ogg";